/**
 * Sentry initialisation for the React frontend. Called once from main.tsx
 * before render. DSN is public (it goes into the bundle), so hardcoding is
 * safe and avoids needing build-time env var injection.
 *
 * Disabled in dev unless VITE_FORCE_SENTRY=1 in web/.env.local, so local
 * console errors don't pollute the prod project.
 */
import * as Sentry from '@sentry/react';

const FRONTEND_DSN =
  'https://2597cb892a5c83bcf94b1f1f05d967c3@o4511486242324480.ingest.de.sentry.io/4511486290362448';

export function initSentry() {
  const force = (import.meta.env.VITE_FORCE_SENTRY as string | undefined) === '1';
  if (!import.meta.env.PROD && !force) {
    // dev mode and not forced: skip
    return;
  }
  Sentry.init({
    dsn: FRONTEND_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
    release: (import.meta.env.VITE_SENTRY_RELEASE as string | undefined) || "unknown",
    // Drop noisy client-side errors that are usually browser/ad-blocker artefacts.
    ignoreErrors: [
      /ResizeObserver loop limit exceeded/,
      /Non-Error promise rejection captured/,
      /Failed to fetch/,
      // Cancelled fetches during navigation
      /AbortError/,
    ],
  });
}

export { Sentry };
